import React from "react";
import { MdPeople } from "react-icons/md";
import {
  FaGlobeAfrica,
  FaBoxOpen,
  FaUser,
  FaComment,
  FaWaveSquare,
  FaCalendar,
  FaLayerGroup,
  FaBell
} from "react-icons/fa";
import { AiOutlineShopping } from "react-icons/ai";
import { FiSettings, FiUploadCloud, FiShoppingCart } from "react-icons/fi";
import {
  IconAccounting,
  IconAutosys,
  IconCloudSync,
  IconEnergyLabel,
  IconLostCart,
  IconWishlist,
  IconRollBack,
  IconTechnorama,
  IconUserGear,
  IconMarketing,
  IconXmlFeedGeneration,
  IconMarketplace,
  IconStatistic
} from "../../../../components/Layout/Icons";
import { TiDocument, TiFolder, TiMessages } from "react-icons/ti";
import { IoIosDocument } from "react-icons/io";
import { GrServices } from "react-icons/gr";

const AvailableMenu = (auth, additional_information = {}) => {
  return [
    {
      uuid: "orders",
      title: "Orders",
      url: "/orders",
      icon: <FaBoxOpen className="mr-3" />,
      action: true,
      options: additional_information.force_payment_accepted_status
        ? [
            {
              uuid: "force_payment_accepted_status",
              title: "Force payment accepted status",
            },
          ]
        : undefined,
    },
    {
      uuid: "wishlist",
      title: "Wishlist insights",
      url: "/wishlist",
      icon: <IconWishlist className="mr-3" width={16} height={16} />,
    },
    {
      uuid: "lost_cart",
      title: "Lost cart",
      url: "/lost_cart",
      icon: <IconLostCart className="mr-3" width={16} height={16} />,
    },
    {
      uuid: "returns",
      title: "Returns",
      url: "/returns",
      icon: <OrderReturnsSvg />,
    },
    {
      uuid: "services",
      title: "Services",
      icon: <TiFolder className="mr-3" />,
      options: [
        {
          uuid: "service/repair",
          title: "Services",
          icon: <TiFolder className="mr-3" />,
          url: "/service/repair",
          action: true,
        },

        {
          uuid: "service/repair/new",
          title: "NEW Services",
          icon: <TiFolder className="mr-3" />,
          url: "/service/repair/new",
          visible: false,
        },

        {
          uuid: "service/contacts",
          title: "Service contacts",
          icon: <TiFolder className="mr-3" />,
          url: "/service/contacts",
        },
      ],
    },
    {
      uuid: "products",
      title: "Products",
      url: "/products",
      icon: <TiMessages className="mr-3" />,
      options: [
        {
          uuid: "products",
          title: "Products",
          icon: false,
          url: "/products",
        },
        {
          uuid: "product_variant_rules",
          title: "Product Variants",
          icon: false,
          url: "/products/product_variant_rules",
        },
        {
          uuid: "product_variant_global_rules",
          title: "Variant Rules",
          icon: false,
          url: "/products/product_variant_global_rules",
        },
      ]
    },
    {
      uuid: "vv_stock",
      title: "VV Stock",
      icon: <VVStock className="mr-3" />,
      options: [
        {
          uuid: "vv_stock_products",
          title: "Products",
          icon: <VVStockProducts className="mr-3" />,
          url: "/vv-stock/products",
          visible: true,
        },
        {
          uuid: "vv_stock_documents",
          title: "Documents",
          icon: <VVStockDocuments className="mr-3" />,
          url: "/vv-stock/documents",
          visible: true,
        },
      ],
      visible: true,
    },
    {
      uuid: "technorama",
      title: "Technorama",
      url: "/technorama",
      icon: <IconTechnorama className="mr-3" />,
      dot: additional_information?.tr_request,
      attributes: {
        bubble: additional_information?.tr_request,
      },
      options: [
        {
          uuid: "technorama/tr_request",
          title: "Requests",
          url: "/technorama/tr_request",
          icon: <TechnoramaRequestSvg className="mr-3" />,
          dot: additional_information?.tr_request,
          attributes: {
            bubble: additional_information?.tr_request,
          },
        },
        {
          uuid: "technorama/tr_request_id",
          title: "Requests SHOW",
          url: "/technorama/tr_request/:show",
          icon: <IconTechnorama className="mr-3" />,
          visible: false,
        },
        {
          uuid: "technorama/documents",
          title: "Documents",
          icon: <TechnoramaDocumentsSvg className="mr-3" />,
          url: "/technorama/documents",
        },
        {
          uuid: "technorama/documentDetails",
          title: "Document Details",
          icon: <TechnoramaDocumentsSvg className="mr-3" />,
          url: "/technorama/documentDetails",
          visible: false,
        },
        {
          uuid: "technorama/pickup_users",
          title: "Pickup users",
          icon: <PickupUserSvg className="mr-3" />,
          url: "/technorama/pickup_users",
        },
        {
          uuid: "technorama/imum",
          title: "IMUM",
          icon: <CloudSvg className="mr-3" />,
          url: "/technorama/imum",
        },
        {
          uuid: "technorama/goods",
          title: "Goods",
          icon: <FiShoppingCart className="mr-3" />,
          url: "/technorama/goods",
          options: [
            {
              uuid: "technorama/goods/descriptions",
              title: "Descriptions",
              icon: false,
              url: "/technorama/goods/descriptions",
            },
            {
              uuid: "technorama/goods/repricings",
              title: "Repricings",
              icon: false,
              url: "/technorama/goods/repricings",
            },
            {
              uuid: "technorama/goods/repricing",
              title: "Perkainavimas",
              url: "/technorama/goods/repricings/:action",
              icon: false,
              visible: false,
            },
            {
              uuid: "technorama/goods/categories",
              title: "Categories",
              url: "/technorama/goods/categories",
              icon: false,
            },
            {
              uuid: "technorama/goods/leasings",
              title: "Leasings",
              url: "/technorama/goods/leasings",
              icon: false,
            },
            {
              uuid: "technorama/goods/brands",
              title: "Brands",
              url: "/technorama/goods/brands",
              icon: false,
            },
          ]
        },

        {
          uuid: "technorama_retail",
          title: "Retail",
          icon: <FiShoppingCart className="mr-3" />,
          url: "/technorama_retail",
          options: [
            {
              uuid: "technorama_retail/retail",
              title: "Retail pricing",
              icon: false,
              url: "/technorama_retail/retail",
            },
          ]
        }
      ],
    },
    {
      uuid: "documents",
      title: "Documents",
      icon: <IoIosDocument className="mr-3" />,
      options: [
        {
          uuid: "documents",
          title: "Documents",
          icon: <IoIosDocument className="mr-3" />,
          url: "/documents",
        },
        {
          uuid: "documents/options",
          title: "Documents settings",
          icon: <TiDocument className="mr-3" />,
          url: "/documents/options",
        },
      ],
    },

    {
      uuid: "delivery",
      title: "Delivery",
      icon: <DeliverySvg className="mr-3" />,
      options: [
        {
          uuid: "deliveries/manifests",
          title: "Manifests",
          icon: <ManifestSvg className="mr-3" />,
          url: "/deliveries/manifests",
        },
        {
          uuid: "deliveries/shipments",
          title: "Shipments",
          icon: <ShipmentSvg className="mr-3" />,
          url: "/deliveries/shipments",
        },
        {
          uuid: "deliveries/management",
          title: "Types management",
          icon: <ManagementSvg className="mr-3" />,
          url: "/deliveries/management",
        },
      ],
    },

    {
      uuid: "bigbox",
      title: "Bigbox",
      icon: <FaBoxOpen className="mr-3" />,
      options: [
        {
          uuid: "autosys",
          title: "Autosys",
          icon: <IconAutosys className="mr-3" fill="#5f5f5f" />,
          url: "/autosys",
        },
        {
          uuid: "pickups/shipments",
          title: "Pickups",
          icon: <FaBoxOpen className="mr-3" />,
          url: "/pickups/shipments",
        },
        {
          uuid: "bigbox/imum",
          title: "IMUM",
          icon: (
            <IconCloudSync
              className="mr-3"
              style={{
                width: 14,
                height: 14,
              }}
            />
          ),
          url: "/bigbox/imum",
        },
        {
          uuid: "xml_feed_generation",
          title: "XML feed generation",
          icon: (
            <IconXmlFeedGeneration
              className="mr-3"
              style={{
                width: 14,
                height: 14,
              }}
            />
          ),
          url: "/xml_feed_generation",
        },
        {
          uuid: "energy_labels",
          title: "Energy labels",
          icon: (
            <IconEnergyLabel
              className="mr-3"
              style={{
                width: 14,
                height: 14,
              }}
            />
          ),
          url: "/energy_labels",
        },
      ],
    },
    {
      uuid: "options",
      title: "Options",
      icon: <FiSettings className="mr-3" />,
      options: [
        {
          uuid: "options/categories",
          title: "Categories",
          icon: <FiSettings className="mr-3" />,
          url: "/options/categories",
        },

        {
          uuid: "options/sms-templates",
          title: "Message templates",
          icon: <AiOutlineShopping className="mr-3" />,
          url: "/options/sms-templates",
        },
        {
          uuid: "options/stores",
          title: "Stores",
          icon: <MdPeople className="mr-3" />,
          url: "/options/stores",
        },
        {
          uuid: "options/suppliers",
          title: "Suppliers",
          icon: <MdPeople className="mr-3" />,
          url: "/options/suppliers",
        },
        {
          uuid: "options/countries",
          title: "Countries",
          icon: <FaGlobeAfrica className="mr-3" />,
          url: "/options/countries",
        },
        //
        {
          uuid: "options/pickup_addresses",
          title: "Pickup addresses",
          icon: <FaUser className="mr-3" />,
          url: "/options/pickup_addresses",
        },

        {
          uuid: "options/users",
          title: "Users",
          icon: <FaUser className="mr-3" />,
          url: "/options/users",
        },
        {
          uuid: "options/user_roles",
          title: "Roles",
          icon: <IconUserGear className="mr-3" />,
          url: "/options/user_roles",
        },
        {
          uuid: "options/warranty_mails",
          title: "Warranty mails",
          icon: <FaWaveSquare className="mr-3" />,
          url: "/options/warranty_mails",
        },
        {
          uuid: "options/rivile",
          title: "Rivile",
          icon: <GrServices className="mr-3" />,
          options: [
            {
              uuid: "options/rivile/stores",
              title: "Stores",
              icon: <GrServices className="mr-3" />,
              url: "/options/rivile/stores",
            },
            {
              uuid: "options/rivile/services",
              title: "Services",
              icon: <GrServices className="mr-3" />,
              url: "/options/rivile/services",
            },
            {
              uuid: "options/rivile/pvm",
              title: "PVM 25",
              icon: <GrServices className="mr-3" />,
              url: "/options/rivile/pvm",
            },
          ],
        },
        {
          uuid: "options/statuses",
          title: "Statuses",
          icon: <TiMessages className="mr-3" />,
          url: "/options/statuses",
        },
        {
          uuid: "options/additional_supplier_codes",
          title: "Additional supplier codes",
          icon: <FaWaveSquare className="mr-3" />,
          url: "/options/additional_supplier_codes",
        },
        {
          uuid: "options/calendar",
          title: "Calendar",
          icon: <FaCalendar className="mr-3" />,
          url: "/options/calendar",
        },
        {
          uuid: "options/payment_method_groups",
          title: "Payment method groups",
          icon: <PaymentMethodGroups className="mr-3" />,
          url: "/options/payment_method_groups",
        },
        {
          uuid: "options/payment_status_groups",
          title: "Payment status groups",
          icon: <FaLayerGroup className="mr-3" />,
          url: "/options/payment_status_groups",
        },
        {
          uuid: "options/blacklist",
          title: "Blacklist",
          icon: <IconBlacklist className="mr-3" />,
          url: "/options/blacklist",
        },
        {
          uuid: "options/comments_state",
          title: "Comments states",
          icon: <FaComment className="mr-3" />,
          url: "/options/comments_state",
        },
        {
          uuid: "options/alerts",
          title: "Alert settings",
          icon: <FaBell className="mr-3" />,
          url: "/options/alerts",
        },
      ],
    },
    {
      uuid: "imports",
      title: "Imports",
      icon: <FiUploadCloud className="mr-3" />,
      options: [
        {
          uuid: "imports/money_refund_lt",
          title: "Money refund LT",
          url: "",
        },
        {
          uuid: "imports/money_refund_lv",
          title: "Money refund LV",
          url: "",
        },
        {
          uuid: "imports/money_refund_ee",
          title: "Money refund EE",
          url: "",
        },
        {
          uuid: "imports/upload_payments_file/sb_leasing",
          title: "SB Leasing ET",
          url: "",
        },
        {
          uuid: "imports/upload_payments_file/sb_leasing",
          title: "SB Leasing VV",
          url: "",
        },
        {
          uuid: "imports/upload_payments_file/dpd",
          title: "DPD",
          url: "",
        },
        {
          uuid: "imports/upload_payments_file/lp_express",
          title: "LP express",
          url: "",
        },
        {
          uuid: "imports/upload_payments_file/venipak",
          title: "Venipak",
          url: "",
        },
        {
          uuid: "imports/upload_payments_file/omniva",
          title: "Omniva",
          url: "",
        },
        {
          uuid: "imports/upload_payments_file/esto",
          title: "Esto",
          url: "",
        },
        {
          uuid: "imports/upload_payments_file/amazon",
          title: "Amazon payment",
          url: "",
        },
        {
          uuid: "imports/upload_payments_file/zipasgo",
          title: "ZipasGo",
          url: "",
        },
        {
          uuid: "imports/upload_payments_file/klarna",
          title: "Klarna",
          url: "",
        },
        {
          uuid: "imports/rivile_lt_identifiers",
          title: "Products to Rivile",
          url: "",
        },
      ],
    },
    {
      uuid: "accounting",
      title: "Accounting",
      icon: <IconAccounting className="mr-3" />,
      options: [
        {
          uuid: "suppliers-invoices",
          title: "Supplier invoices",
          icon: <TiDocument className="mr-3" />,
          url: "/suppliers-invoices",
        },
        {
          uuid: "accounting/refunds",
          title: "Refunds",
          icon: <IconRollBack className="mr-3" color={"#000"} />,
          url: "/accounting/refunds",
        },
      ],
    },
    {
      uuid: "also_income_module",
      title: "3PL incomes",
      icon: <TiMessages className="mr-3" />,
      url: "/also_income_module",
      options: [
        {
          uuid: "also_income_module_id",
          title: "3PL incomes show",
          icon: <TiMessages className="mr-3" />,
          url: "/also_income_module/:show",
          visible: false,
        },
        {
          uuid: "also_income_module_create_po",
          title: "Create 3PL income",
          icon: <TiMessages className="mr-3" />,
          visible: false,
        },
        {
          uuid: "also_income_module_export_to_also",
          title: "Export to warehouse",
          icon: <TiMessages className="mr-3" />,
          visible: false,
        },
      ]
    },
    {
      uuid: "marketing",
      title: "Marketing",
      icon: <IconMarketing className="mr-3" />,
      options: [
        {
          uuid: "features",
          title: "Features",
          icon: <></>,
          url: "/marketing/features",
        },
        {
          uuid: "marketing/info_zone_manager",
          title: "Info Zone Manager",
          icon: <></>,
          url: "/marketing/info_zone_manager",
        },
        {
          uuid: "reviews",
          title: "Reviews",
          icon: <></>,
          url: "/marketing/reviews",
          visible: true,
        },
        {
          uuid: "review_emails",
          title: "Review emails",
          icon: <></>,
          url: "/marketing/review_emails",
          visible: true,
        },
        {
          uuid: "marketing/category_attribute_map",
          title: "Category Attribute Map",
          icon: <></>,
          url: "/marketing/category_attribute_maps",
        },
        {
          uuid: "options/attr_mapper",
          title: "Attributes Mapper",
          icon: <></>,
          url: "/options/attr_mapper",
          visible: true,
        },
      ],
    },
    {
      uuid: "marketplace",
      title: "Marketplace",
      icon: <IconMarketplace className="mr-3" />,
      options: [
        {
          uuid: "marketplace/products",
          title: "Products",
          icon: <></>,
          url: "/marketplace/products",
          visible: true,
        },
        {
          uuid: "marketplace/rules",
          title: "Rules",
          icon: <></>,
          url: "/marketplace/rules",
          visible: false,
        },
        {
          uuid: "marketplace/history",
          title: "History",
          icon: <></>,
          url: "/marketplace/history",
          visible: false,
        },
      ],
    },
    {
      uuid: "statistic",
      title: "Statistic",
      icon: <IconStatistic className="mr-3" />,
      url: "/statistic",
      visible: true,
    },
    {
      uuid: "nordrent_orders",
      title: "Nordrent Orders",
      icon: <FaBoxOpen className="mr-3" />,
      url: "/nordrent_orders",
      action: true,
    },
    //
  ];
};

export default AvailableMenu;

const DeliverySvg = () => (
  <svg
    className="mr-2"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 21 27"
    fill="none"
  >
    <g clipPath="url(#clip0_7_75)">
      <path
        d="M8.6989 10.5493L9.12806 12.1018C9.53223 13.5643 9.7339 14.296 10.3281 14.6285C10.9222 14.9618 11.6764 14.7652 13.1847 14.3735L14.7847 13.9568C16.2931 13.5652 17.0472 13.3693 17.3906 12.7935C17.7339 12.2168 17.5322 11.4852 17.1272 10.0227L16.6989 8.471C16.2947 7.00766 16.0922 6.276 15.4989 5.9435C14.9039 5.61016 14.1497 5.80683 12.6414 6.19933L11.0414 6.61433C9.53306 7.006 8.7789 7.20266 8.4364 7.77933C8.09306 8.35516 8.29473 9.08683 8.6989 10.5493Z"
        fill="#212121"
      />
      <path
        d="M2.62642 7.6469C2.64837 7.56775 2.68571 7.49371 2.7363 7.429C2.78689 7.3643 2.84974 7.3102 2.92125 7.2698C2.99277 7.2294 3.07154 7.20349 3.15307 7.19355C3.2346 7.18362 3.31729 7.18985 3.39642 7.2119L4.81558 7.60523C5.1917 7.70738 5.53494 7.90523 5.81184 8.1795C6.08874 8.45377 6.28985 8.7951 6.39558 9.17023L8.18808 15.6586L8.31975 16.1136C8.84725 16.3111 9.30058 16.6802 9.58808 17.1702L9.84642 17.0902L17.2381 15.1694C17.3175 15.1487 17.4003 15.1439 17.4816 15.1552C17.5629 15.1665 17.6412 15.1937 17.712 15.2352C17.7828 15.2768 17.8447 15.3319 17.8943 15.3974C17.9438 15.4628 17.9799 15.5374 18.0006 15.6169C18.0213 15.6963 18.0261 15.7791 18.0148 15.8604C18.0035 15.9417 17.9763 16.02 17.9348 16.0908C17.8932 16.1616 17.8381 16.2236 17.7726 16.2731C17.7071 16.3226 17.6325 16.3587 17.5531 16.3794L10.1881 18.2927L9.91475 18.3777C9.90892 19.4361 9.17808 20.4036 8.07308 20.6911C6.74725 21.0361 5.38475 20.2727 5.02975 18.9877C4.67475 17.7019 5.46142 16.3802 6.78642 16.0361C6.85171 16.0192 6.91758 16.0048 6.98392 15.9927L5.19058 9.50273C5.14231 9.33599 5.0517 9.18458 4.92758 9.06323C4.80345 8.94188 4.65004 8.85472 4.48225 8.81023L3.06225 8.41606C2.98312 8.39419 2.90907 8.35694 2.84434 8.30645C2.77961 8.25595 2.72546 8.1932 2.68499 8.12177C2.64451 8.05034 2.61851 7.97164 2.60846 7.89016C2.59841 7.80868 2.60451 7.72602 2.62642 7.6469Z"
        fill="#212121"
      />
    </g>
    <defs>
      <clipPath id="clip0_7_75">
        <rect
          width="20"
          height="25.8469"
          fill="white"
          transform="translate(0.728882 0.351074)"
        />
      </clipPath>
    </defs>
  </svg>
);

const ManifestSvg = () => (
  <svg
    className="mr-3"
    width="14"
    height="14"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.782666 0.948193C0.098999 1.63128 0.098999 2.73144 0.098999 4.93119V7.26453C0.098999 9.46428 0.098999 10.5644 0.782666 11.2475C1.46575 11.9312 2.56592 11.9312 4.76567 11.9312H5.93233C8.13208 11.9312 9.23225 11.9312 9.91533 11.2475C10.599 10.5644 10.599 9.46428 10.599 7.26453V4.93119C10.599 2.73144 10.599 1.63128 9.91533 0.948193C9.23225 0.264526 8.13208 0.264526 5.93233 0.264526H4.76567C2.56592 0.264526 1.46575 0.264526 0.782666 0.948193ZM3.01567 4.49369C2.89963 4.49369 2.78835 4.53979 2.70631 4.62183C2.62426 4.70388 2.57817 4.81516 2.57817 4.93119C2.57817 5.04722 2.62426 5.1585 2.70631 5.24055C2.78835 5.3226 2.89963 5.36869 3.01567 5.36869H7.68233C7.79836 5.36869 7.90964 5.3226 7.99169 5.24055C8.07374 5.1585 8.11983 5.04722 8.11983 4.93119C8.11983 4.81516 8.07374 4.70388 7.99169 4.62183C7.90964 4.53979 7.79836 4.49369 7.68233 4.49369H3.01567ZM3.01567 6.82703C2.89963 6.82703 2.78835 6.87312 2.70631 6.95517C2.62426 7.03721 2.57817 7.14849 2.57817 7.26453C2.57817 7.38056 2.62426 7.49184 2.70631 7.57388C2.78835 7.65593 2.89963 7.70203 3.01567 7.70203H5.93233C6.04836 7.70203 6.15964 7.65593 6.24169 7.57388C6.32374 7.49184 6.36983 7.38056 6.36983 7.26453C6.36983 7.14849 6.32374 7.03721 6.24169 6.95517C6.15964 6.87312 6.04836 6.82703 5.93233 6.82703H3.01567Z"
      fill="#5f5f5f"
    />
  </svg>
);

const ShipmentSvg = () => (
  <svg
    className="mr-3"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 12 13"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.07828 2L1.37361 4.25867C1.25648 4.45924 1.17865 4.68029 1.14428 4.91L1.07628 5.362C0.812568 7.11645 0.837339 8.9022 1.14961 10.6487C1.2113 10.9935 1.38379 11.3087 1.64091 11.5466C1.89803 11.7845 2.22573 11.9319 2.57428 11.9667L3.39428 12.0487C5.35961 12.2433 7.33828 12.2433 9.30295 12.0487L10.1229 11.9673C10.4717 11.9327 10.7996 11.7852 11.0569 11.5472C11.3142 11.3092 11.4867 10.9937 11.5483 10.6487C11.8609 8.902 11.8856 7.11667 11.6216 5.362L11.5536 4.91C11.518 4.67101 11.4353 4.44147 11.3103 4.23467L10.6189 2.00333C10.5312 1.72001 10.3647 1.46753 10.1387 1.27544C9.91271 1.08335 9.63669 0.959601 9.34295 0.918665C7.35629 0.642265 5.34094 0.642265 3.35428 0.918665C3.06096 0.959413 2.78527 1.0827 2.55935 1.27415C2.33343 1.46561 2.16659 1.71734 2.07828 2ZM9.20495 1.90867C7.30963 1.64496 5.38693 1.64496 3.49161 1.90867C3.38613 1.92342 3.287 1.96786 3.2058 2.03679C3.12459 2.10572 3.06465 2.19631 3.03295 2.298L2.69895 3.36867C2.72361 3.36533 2.74895 3.362 2.77428 3.36L3.42628 3.29533C5.37028 3.102 7.32761 3.102 9.27162 3.29533L9.92361 3.36C9.94761 3.362 9.97095 3.36533 9.99495 3.368L9.66361 2.29867C9.63217 2.19677 9.57231 2.10596 9.49107 2.03688C9.40983 1.9678 9.31057 1.92332 9.20495 1.90867ZM9.01561 6.50667C9.14822 6.50667 9.2754 6.45399 9.36917 6.36022C9.46294 6.26645 9.51561 6.13927 9.51561 6.00667C9.51561 5.87406 9.46294 5.74688 9.36917 5.65311C9.2754 5.55934 9.14822 5.50667 9.01561 5.50667H3.68228C3.54967 5.50667 3.4225 5.55934 3.32873 5.65311C3.23496 5.74688 3.18228 5.87406 3.18228 6.00667C3.18228 6.13927 3.23496 6.26645 3.32873 6.36022C3.4225 6.45399 3.54967 6.50667 3.68228 6.50667H9.01561Z"
      fill="#5f5f5f"
    />
  </svg>
);

const CloudSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 10 11"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_45_546)">
      <path
        d="M5.41675 7.71167C5.41675 8.0825 5.49175 8.4325 5.62508 8.75334H2.70841C2.08341 8.75334 1.53758 8.545 1.08758 8.09917C0.641748 7.66167 0.416748 7.12417 0.416748 6.495C0.416748 5.95334 0.579248 5.47 0.904248 5.045C1.22925 4.62 1.66675 4.34917 2.18758 4.2325C2.36258 3.595 2.70841 3.07834 3.22925 2.6825C3.75008 2.28667 4.34175 2.08667 5.00008 2.08667C5.81258 2.08667 6.50008 2.37 7.06675 2.93667C7.63341 3.50334 7.91675 4.19084 7.91675 5.00334H7.95842C6.54175 5.09917 5.41675 6.27417 5.41675 7.71167ZM7.91675 6.045V5.42L6.97925 6.3575L7.91675 7.295V6.67C8.19302 6.67 8.45797 6.77975 8.65332 6.9751C8.84867 7.17045 8.95842 7.4354 8.95842 7.71167C8.95842 7.87834 8.92091 8.03667 8.85008 8.17834L9.30425 8.6325C9.47925 8.37 9.58342 8.05334 9.58342 7.71167C9.58342 6.79084 8.83758 6.045 7.91675 6.045ZM7.91675 8.75334C7.64048 8.75334 7.37553 8.64359 7.18018 8.44824C6.98483 8.25289 6.87508 7.98794 6.87508 7.71167C6.87508 7.545 6.91258 7.38667 6.98342 7.245L6.52925 6.79084C6.35425 7.05334 6.25008 7.37 6.25008 7.71167C6.25008 8.6325 6.99591 9.37834 7.91675 9.37834V10.0033L8.85425 9.06584L7.91675 8.12834V8.75334Z"
        fill="#5F5F5F"
      />
    </g>
    <defs>
      <clipPath id="clip0_45_546">
        <rect
          width="10"
          height="10"
          fill="white"
          transform="translate(0 0.420013)"
        />
      </clipPath>
    </defs>
  </svg>
);

const TechnoramaRequestSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 8 11"
    fill="none"
    {...props}
  >
    <path
      d="M7.62078 5.83185C7.62078 7.15817 7.62078 8.48058 7.62078 9.8069C7.62078 10.2881 7.32735 10.6755 6.87351 10.7889C6.78743 10.8124 6.69353 10.8202 6.60355 10.8202C4.78426 10.8202 2.96888 10.8202 1.14959 10.8202C0.554901 10.8202 0.128444 10.3899 0.128444 9.79908C0.128444 7.14644 0.128444 4.4938 0.128444 1.84116C0.124532 1.25429 0.554901 0.820007 1.13786 0.820007C2.96106 0.820007 4.78035 0.820007 6.60355 0.820007C7.19433 0.820007 7.62078 1.25038 7.62078 1.84507C7.62078 3.17139 7.62078 4.50162 7.62078 5.82794V5.83185ZM3.8531 1.90767C3.77876 1.91549 3.70442 1.91941 3.63009 1.93506C3.17233 2.03287 2.86325 2.30283 2.70675 2.74102C2.64806 2.90925 2.73022 3.0814 2.88672 3.14009C3.05104 3.20269 3.21928 3.12444 3.2897 2.95229C3.30144 2.92099 3.31318 2.88969 3.32491 2.86231C3.43055 2.64321 3.65747 2.51801 3.90004 2.53757C4.13088 2.55713 4.3265 2.71754 4.39693 2.94447C4.47909 3.21051 4.37736 3.46873 4.11914 3.62915C3.7279 3.87172 3.53227 4.22384 3.53227 4.68551C3.53227 4.85374 3.67312 4.99068 3.83745 4.99068C3.99786 4.99068 4.15044 4.86939 4.15044 4.70507C4.15044 4.43511 4.27955 4.25905 4.50256 4.1182C4.95249 3.83651 5.14812 3.28094 4.99553 2.76841C4.84294 2.25979 4.37345 1.90767 3.84136 1.90376L3.8531 1.90767ZM3.87266 7.06819C4.52995 7.06819 5.18724 7.06819 5.84453 7.06819C5.92278 7.06819 6.00103 7.06819 6.07928 7.06819C6.23578 7.06036 6.36097 6.93516 6.37271 6.77867C6.38445 6.62608 6.27881 6.48132 6.12623 6.45002C6.0871 6.4422 6.04407 6.4422 6.00103 6.4422C4.58472 6.4422 3.17233 6.4422 1.75602 6.4422C1.72864 6.4422 1.69734 6.4422 1.66995 6.4422C1.54084 6.45393 1.45085 6.52044 1.4039 6.64173C1.31783 6.853 1.47433 7.06428 1.71299 7.06819C2.43679 7.06819 3.15668 7.06819 3.88048 7.06819H3.87266ZM3.87266 7.69418C3.46968 7.69418 3.06669 7.69418 2.66371 7.69418C2.33898 7.69418 2.01424 7.69418 1.68951 7.69418C1.52519 7.69418 1.39608 7.81546 1.38043 7.97588C1.36478 8.13237 1.47041 8.28105 1.63082 8.31235C1.66995 8.32017 1.71299 8.32017 1.75602 8.32017C2.89455 8.32017 4.03307 8.32017 5.17159 8.32017C5.46502 8.32017 5.75846 8.32017 6.04798 8.32017C6.19274 8.32017 6.3062 8.24192 6.35315 8.12064C6.43531 7.90936 6.27881 7.69809 6.04015 7.69809C5.31635 7.69809 4.59646 7.69809 3.87266 7.69809V7.69418ZM3.87657 8.94225C3.69268 8.94225 3.50489 8.94225 3.321 8.94225C2.77717 8.94225 2.23334 8.94225 1.69342 8.94225C1.52519 8.94225 1.39608 9.05962 1.37652 9.21612C1.35695 9.37262 1.46259 9.52129 1.61909 9.55651C1.66212 9.56433 1.70907 9.56433 1.75602 9.56433C3.15668 9.56433 4.56125 9.56433 5.96191 9.56433C6.00103 9.56433 6.04015 9.56433 6.07928 9.56433C6.2123 9.55259 6.3062 9.48608 6.35315 9.36088C6.43531 9.14961 6.27881 8.94225 6.03624 8.94225C5.31635 8.94225 4.60037 8.94225 3.88048 8.94225H3.87657ZM3.5401 5.65579C3.5401 5.82403 3.67704 5.96879 3.84136 5.9727C4.01742 5.9727 4.15827 5.83968 4.16218 5.66362C4.16218 5.49538 4.02916 5.35454 3.85701 5.35062C3.68486 5.35062 3.54401 5.48365 3.5401 5.65188V5.65579Z"
      fill="#5F5F5F"
    />
  </svg>
);

const PickupUserSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 10 11"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_45_428)">
      <path
        d="M5.03978 10.4219C4.77253 10.1626 4.50927 9.91134 4.24602 9.66005C3.51608 8.95405 2.77417 8.26 2.05221 7.54602C1.33423 6.83602 0.943337 5.96648 0.855585 4.95732C0.723956 3.49744 1.47384 1.74639 3.04939 0.912738C3.78731 0.517852 4.58107 0.354314 5.41073 0.442066C6.99825 0.605604 8.16296 1.41133 8.82111 2.86722C9.52711 4.42682 9.33167 5.90266 8.27864 7.25883C8.18291 7.38248 8.07521 7.49417 7.96353 7.60186C7.00623 8.53124 6.04494 9.45663 5.08764 10.382C5.07568 10.394 5.06371 10.4059 5.03978 10.4259V10.4219ZM7.42505 2.56408H2.65451V6.68844H7.42106V2.56408H7.42505Z"
        fill="#5F5F5F"
      />
      <path
        d="M3.29272 3.19431H4.07851V4.45874H5.98912V3.19829H6.78288V6.05423H3.29272V3.19431Z"
        fill="#5F5F5F"
      />
      <path
        d="M4.72461 3.19431H5.34685V3.82453H4.72461V3.19431Z"
        fill="#5F5F5F"
      />
    </g>
    <defs>
      <clipPath id="clip0_45_428">
        <rect
          width="10"
          height="10.0038"
          fill="white"
          transform="translate(0 0.418121)"
        />
      </clipPath>
    </defs>
  </svg>
);

const OrderReturnsSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    className="mr-3"
  >
    <path
      d="M11.5775 11.0301C11.155 11.0301 10.7575 10.8051 10.5425 10.4451L8.93502 7.78012L7.33002 10.4451C7.11252 10.8076 6.71502 11.0326 6.29252 11.0326C6.18002 11.0326 6.06752 11.0176 5.96002 10.9851L2.53502 10.0051V14.4551C2.53502 14.8226 2.78502 15.1426 3.14002 15.2301L8.54502 16.5826C8.80002 16.6451 9.06752 16.6451 9.32002 16.5826L14.73 15.2301C15.085 15.1401 15.335 14.8201 15.335 14.4551V10.0051L11.91 10.9826C11.8025 11.0151 11.69 11.0301 11.5775 11.0301ZM16.8925 8.22512L15.605 5.65512C15.5275 5.50012 15.36 5.41012 15.1875 5.43262L8.93502 6.23012L11.2275 10.0326C11.3225 10.1901 11.5125 10.2651 11.69 10.2151L16.6375 8.80262C16.885 8.73012 17.005 8.45512 16.8925 8.22512ZM2.26502 5.65512L0.977518 8.22512C0.862518 8.45512 0.985018 8.73012 1.23002 8.80012L6.17752 10.2126C6.35502 10.2626 6.54502 10.1876 6.64002 10.0301L8.93502 6.23012L2.68002 5.43262C2.50752 5.41262 2.34252 5.50012 2.26502 5.65512Z"
      fill="#212121"
    />
    <rect x="10.5" y="0.500488" width="9" height="9" rx="4.5" fill="#212121" />
    <rect x="10.5" y="0.500488" width="9" height="9" rx="4.5" stroke="white" />
    <g clipPath="url(#clip0_8_8952)">
      <path
        d="M16.6465 3.41855H14.1445V2.98496C14.1445 2.9457 14.0994 2.92402 14.0689 2.94804L13.2369 3.60429C13.2313 3.60868 13.2268 3.61428 13.2237 3.62068C13.2205 3.62707 13.2189 3.63409 13.2189 3.64121C13.2189 3.64832 13.2205 3.65534 13.2237 3.66174C13.2268 3.66814 13.2313 3.67374 13.2369 3.67812L14.0689 4.33437C14.0994 4.3584 14.1445 4.33672 14.1445 4.29746V3.86386H16.5762V6.61777H13.0254C12.9996 6.61777 12.9785 6.63886 12.9785 6.66465V7.01621C12.9785 7.04199 12.9996 7.06308 13.0254 7.06308H16.6465C16.8533 7.06308 17.0215 6.89492 17.0215 6.68808V3.79355C17.0215 3.58672 16.8533 3.41855 16.6465 3.41855Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_8_8952">
        <rect
          width="6"
          height="6"
          fill="white"
          transform="translate(12 2.00049)"
        />
      </clipPath>
    </defs>
  </svg>
);
const ManagementSvg = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.66669 10.5001C4.34585 10.5001 4.0713 10.3859 3.84302 10.1577C3.61474 9.92939 3.50041 9.65464 3.50002 9.33342V2.33341C3.50002 2.01258 3.61435 1.73803 3.84302 1.50975C4.07169 1.28147 4.34624 1.16714 4.66669 1.16675H11.6667C11.9875 1.16675 12.2623 1.28108 12.4909 1.50975C12.7196 1.73841 12.8337 2.01297 12.8334 2.33341V9.33342C12.8334 9.65425 12.7192 9.929 12.4909 10.1577C12.2627 10.3863 11.9879 10.5005 11.6667 10.5001H4.66669ZM4.66669 3.50008H11.6667V2.33341H4.66669V3.50008ZM2.33335 12.8334C2.01252 12.8334 1.73796 12.7193 1.50969 12.491C1.28141 12.2627 1.16708 11.988 1.16669 11.6667V3.50008H2.33335V11.6667H10.5V12.8334H2.33335Z"
      fill="#5F5F5F"
    />
  </svg>
);

const PaymentMethodGroups = (props) => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.5 0H12.5V12H0.5V0ZM1.83333 1.33333V10.6667H11.1667V1.33333H1.83333ZM3.16667 2.66667H5.83333V5.33333H3.16667V2.66667ZM7.16667 2.66667H9.83333V5.33333H7.16667V2.66667ZM3.16667 6.66667H5.83333V9.33333H3.16667V6.66667ZM7.16667 6.66667H9.83333V9.33333H7.16667V6.66667Z"
      fill="black"
    />
  </svg>
);

const VVStockProducts = (props) => (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10.705 6.68014L6.205 2.18014C6.01751 1.99418 5.76407 1.88993 5.5 1.89014H2C1.73478 1.89014 1.48043 1.99549 1.29289 2.18303C1.10536 2.37057 1 2.62492 1 2.89014V6.39014C0.999896 6.52209 1.02591 6.65276 1.07654 6.77462C1.12717 6.89648 1.20142 7.00711 1.295 7.10014L5.795 11.6001C5.98249 11.7861 6.23593 11.8903 6.5 11.8901C6.76479 11.889 7.01833 11.7829 7.205 11.5951L10.705 8.09514C10.8928 7.90846 10.9989 7.65493 11 7.39014C11.0001 7.25818 10.9741 7.12751 10.9235 7.00565C10.8728 6.8838 10.7986 6.77317 10.705 6.68014ZM6.5 10.8901L2 6.39014V2.89014H5.5L10 7.39014M3.25 3.39014C3.39834 3.39014 3.54334 3.43412 3.66668 3.51653C3.79001 3.59895 3.88614 3.71608 3.94291 3.85312C3.99968 3.99017 4.01453 4.14097 3.98559 4.28645C3.95665 4.43194 3.88522 4.56558 3.78033 4.67047C3.67544 4.77536 3.5418 4.84679 3.39632 4.87573C3.25083 4.90466 3.10003 4.88981 2.96299 4.83305C2.82594 4.77628 2.70881 4.68015 2.6264 4.55681C2.54399 4.43348 2.5 4.28847 2.5 4.14014C2.5 3.94122 2.57902 3.75046 2.71967 3.60981C2.86032 3.46915 3.05109 3.39014 3.25 3.39014Z" fill="black" />
  </svg>
)

const VVStockDocuments = (props) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.8535 3.6465L7.8535 1.6465C7.76 1.5525 7.633 1.5 7.5 1.5H3.5C2.673 1.5 2 2.173 2 3V9C2 9.827 2.673 10.5 3.5 10.5H8.5C9.327 10.5 10 9.827 10 9V4C10 3.867 9.9475 3.74 9.8535 3.6465ZM8.793 4H8.25C7.8365 4 7.5 3.6635 7.5 3.25V2.707L8.793 4ZM8.5 9.5H3.5C3.224 9.5 3 9.276 3 9V3C3 2.724 3.224 2.5 3.5 2.5H7V3.25C7 3.9395 7.5605 4.5 8.25 4.5H9V9C9 9.276 8.776 9.5 8.5 9.5Z" fill="#5F5F5F" />
  </svg>
)

const VVStock = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_53_4798)">
      <path d="M12 6V0H4V6H0V13H16V6H12ZM7 12H1V7H3V8H5V7H7V12ZM5 6V1H7V2H9V1H11V6H5ZM15 12H9V7H11V8H13V7H15V12ZM0 16H3V15H13V16H16V14H0V16Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_53_4798">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
const TechnoramaDocumentsSvg = (props) => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 5.12976C3.39782 5.12976 3.77936 4.97173 4.06066 4.69042C4.34196 4.40912 4.5 4.02759 4.5 3.62976C4.5 3.23194 4.34196 2.85041 4.06066 2.5691C3.77936 2.2878 3.39782 2.12976 3 2.12976C2.60218 2.12976 2.22064 2.2878 1.93934 2.5691C1.65804 2.85041 1.5 3.23194 1.5 3.62976C1.5 4.02759 1.65804 4.40912 1.93934 4.69042C2.22064 4.97173 2.60218 5.12976 3 5.12976ZM3 5.12976V11.1298M9 8.12976C9.39782 8.12976 9.77936 8.2878 10.0607 8.5691C10.342 8.8504 10.5 9.23194 10.5 9.62976C10.5 10.0276 10.342 10.4091 10.0607 10.6904C9.77936 10.9717 9.39782 11.1298 9 11.1298C8.60218 11.1298 8.22064 10.9717 7.93934 10.6904C7.65804 10.4091 7.5 10.0276 7.5 9.62976C7.5 9.23194 7.65804 8.8504 7.93934 8.5691C8.22064 8.2878 8.60218 8.12976 9 8.12976ZM9 8.12976V4.37976C9 4.11454 8.89464 3.86019 8.70711 3.67265C8.51957 3.48512 8.26522 3.37976 8 3.37976H6.75"
      stroke="#5F5F5F"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.25 4.62976L6 3.37976L7.25 2.12976"
      stroke="#5F5F5F"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconBlacklist = (props) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_99_452)">
      <path d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z" stroke="#212121" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 9.66675H7.00667V9.67341H7V9.66675Z" stroke="#212121" strokeWidth="2.25" strokeLinejoin="round" />
      <path d="M7 6.99992V4.33325" stroke="#212121" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_99_452">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
